<template>
  <div class="containter" v-loading='loading'>
    <div class="topSelect">
      <div class="item">
        <label>记账月份：</label>
        <el-date-picker @change="init({page:1})" style="width:140px;" v-model="change_month" :clearable='true' type="month" size="mini" value-format="yyyy-MM" placeholder="月份筛选">
        </el-date-picker>
      </div>
      <div class="item">
        <label>订单数据：</label>
        <el-select v-model="back_type" @change="init({page:1})" style="width:150px" size="mini" clearable placeholder="订单数据">
          <el-option v-for="(item,index) in typeList" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <label>任务ID：</label>
        <el-input placeholder="请输入任务ID" v-model.trim="task_id" clearable @keydown.enter.native="task_id?init({page:1}):''" @clear="init({page:1})" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="task_id?init({page:1}):''" style="padding:0 10px"></el-button>
        </el-input>
      </div>
      <div class="item">
        <label>签约公司：</label>
        <el-input placeholder="请输入签约公司" v-model.trim="company" clearable @keydown.enter.native="company?init({page:1}):''" @clear="init({page:1})" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="company?init({page:1}):''" style="padding:0 10px"></el-button>
        </el-input>
      </div>
      <div class="item">
        <label>客户全称：</label>
        <el-input placeholder="请输入客户全称" v-model.trim="customer_name" clearable @keydown.enter.native="customer_name?init({page:1}):''" @clear="init({page:1})" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="customer_name?init({page:1}):''" style="padding:0 10px"></el-button>
        </el-input>
      </div>
      <div class="item">
        <label>成本公司：</label>
        <el-select v-model="cost_company_name" size="mini" clearable placeholder="请选择" @change="init({ page: 1 })">
          <el-option v-for="(item,index) in costCompanysList" :key="index" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="item">
        <label>mcn返点机构全称：</label>
        <el-input placeholder="mcn返点机构全称" v-model.trim="mcn_name" clearable @keydown.enter.native="mcn_name?init({page:1}):''" @clear="init({page:1})" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="mcn_name?init({page:1}):''" style="padding:0 10px"></el-button>
        </el-input>
      </div>
      <div class="item" style="float:right">
        <div class="batchDelete" @click="exportBackUp">预约导出</div>
      </div>
    </div>
    <div>
      <ux-grid ref="plxTable1" :height="height" show-footer-overflow="tooltip" show-overflow="tooltip" keep-source :edit-config="{trigger: 'manual', mode: 'row'}" size="mini">
        <ux-table-column title="实际消耗月份" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="100">
          <template v-slot="{ row }">{{row.order_original_month}}</template>
        </ux-table-column>
        <ux-table-column title="当月实际消耗月份" align="center" show-header-overflow='tooltip' :resizable="true" minWidth="130">
          <template v-slot="{ row }">{{row.original_order_original_month}}</template>
        </ux-table-column>
        <ux-table-column v-for="item in columns" :key="item.id" :resizable="true" :field="item.prop" :title="item.label" :width="item.width" :fixed="item.fixed" show-header-overflow='tooltip' :edit-render="false" align="center" />
        <ux-table-column title="提交修改后开票" align="center" minWidth="140" show-header-overflow='tooltip'>
          <template v-slot="{ row }">
            <span>{{row.is_edit_invoiced==1?'是':''}}</span>
          </template>
        </ux-table-column>
      </ux-grid>
      <div class="paginationBox">
        <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import columnsJson from '../../Order/json/total.js'
export default {
  components: {
  },
  data () {
    return {
      pickerOptionsMonth: {
        disabledDate (time) {
          return time.getTime() > new Date('2021-03-31 00:00:00');
        },
      },
      height: 400,
      columns: [],
      page: 1,
      page_size: 100,
      total: 0,
      loading: false,
      change_month: '',
      back_type: '',
      typeList: [
        { id: '', name: '全部订单' },
        { id: 1, name: '系统当月订单' },
        { id: 2, name: '系统修改订单' },
        { id: 5, name: '系统开票数据' },
        { id: 3, name: '4月前修改订单' },
        { id: 4, name: '4月前开票数据' },
      ],
      task_id: '',
      company: '',
      customer_name: '',
      cost_company_name: '',
      costCompanysList: [],
      mcn_name: ''
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.columns = columnsJson
    var date = new Date();
    this.change_month = date.getFullYear() + '-' + (date.getMonth());
    this.costCompanys()
    this.init({ page: 1 })
  },
  mounted () {
    this.height = document.documentElement.clientHeight - 208 > 400 ? document.documentElement.clientHeight - 208 : 400
  },
  methods: {
    exportBackUp () {//预约导出
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.backup_export, {
        params: {
          change_month: this.change_month,
          back_type: this.back_type,
          task_id: this.task_id,
          company: this.company,
          customer_name: this.customer_name,
          cost_company_name: this.cost_company_name,
          mcn_name: this.mcn_name
        }
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.$alert('导出预约成功，请稍后到【导出列表】下载文件！', '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '知道了',
            callback: action => {
            }
          });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    handleCurrentChange (val) {
      this.init({ page: val })
    },
    init ({ page, exportFlag, selection }) {
      var params = {
        page: page,
        pagesize: this.page_size,
        change_month: this.change_month,
        back_type: this.back_type,
        task_id: this.task_id,
        company: this.company,
        customer_name: this.customer_name,
        cost_company_name: this.cost_company_name,
        mcn_name: this.mcn_name
      }
      if (exportFlag) {
        params.page = 1;
        params.pagesize = 20000
      } else {
        page = page ? page : 1;
        params.page = page;
        this.page = page;
      }
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.backup_index, {
        params
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          var data = res.rst;
          if (exportFlag) {
            this.$exportOrder({ source: 'all', dataList: data.data, name: this.change_month + '(' + (this.typeList.filter((v => { return v.id == this.back_type }))[0].name) + ')记账列表' })
          } else {
            this.total = data.pageInfo.total;
            this.datas = data.data // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
            this.$refs.plxTable1.reloadData(this.datas)
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    costCompanys () {//成本公司全程列表
      this.$axios.get(this.URL.BASEURL + this.URL.costCompanys, {
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.costCompanysList = res.rst;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../statements/list.scss";
.operationUploadBox {
  margin: 0px 20px 10px;
}
.operationUploadFlex {
  display: flex;
  align-items: center;
}
.operationUpload {
  flex: 1;
}
.fileTemplate {
  font-size: 12px;
  margin-right: 10px;
  text-decoration: underline;
  margin: 8px 10px 0 0;
  color: #5b7bfe;
  display: block;
}
.batchDelete {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5b7bfe;
  background: #5b7bfe;
  color: #fff;
  margin-right: 16px;
  cursor: pointer;
  padding: 0 4px;
}
.refreshIcon {
  margin-right: 10px;
  background: #67c23a;
  border-color: #67c23a;
}
</style>
<style lang="scss">
.topSelect {
  .el-range-editor--mini .el-range-separator {
    width: 20px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/order/backupList.vue